import React, { useCallback } from 'react';

import {
  AccountManager,
  constants,
  SettingsManager,
  useApplicationState,
  useSettings,
} from '@atlas/core';
import { Icon } from '@atlas/ui';

import useTranslate from 'common/I18n/Interpreter';

const { NO, UP, YES } = constants.ACCEPT_ODDS_CHANGES_TYPES;
const ACCEPT_ODDS_CHANGES_OPTIONS = [
  {
    text: 'Always accept',
    value: YES,
  },
  {
    text: 'Accept ascending only',
    value: UP,
  },
  {
    text: 'Always ask',
    value: NO,
  },
];

const AcceptOddsChangesSelect = () => {
  const { acceptOddsChanges } = useSettings();
  const {
    authenticated,
    preferences: { data: preferences },
  } = useApplicationState();
  const t = useTranslate();
  const updateAcceptOddsChangesHandler = useCallback(
    event => {
      if (authenticated) {
        AccountManager.setClientPreferences({
          ...preferences,
          acceptOddsChanges: event.target.value,
        });
      } else {
        SettingsManager.updateSettings({ acceptOddsChanges: event.target.value });
      }
    },
    [acceptOddsChanges, preferences.acceptOddsChanges, preferences.oddsFormat],
  );

  return (
    <div className="btn secondary icon-settings">
      <Icon className="icon-settings" name="settings" />
      <select
        className="accept-odds-changes-select"
        onChange={updateAcceptOddsChangesHandler}
        value={acceptOddsChanges}
      >
        {ACCEPT_ODDS_CHANGES_OPTIONS.map(({ text, value }) => (
          <option key={value} value={value}>
            {t(text)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default AcceptOddsChangesSelect;
